import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers) => {
        const token = localStorage.getItem('authtoken');
        if (token) {
            headers.set('Authorization', `Bearer ${token}`);
        }
        return headers;
    },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions);

    if (result.error && result.error.status === 401) {
        localStorage.removeItem('authtoken');
        // You could also trigger a logout action or redirect user
    }

    return result;
};

export const StaffApi = createApi({
    reducerPath: 'StaffApi',
    baseQuery: baseQueryWithReauth,
    endpoints: (builder) => ({
        getStaff: builder.query({
            query: () => `/accounts/list-branch-domain`,
        }),
        getStafflist: builder.query({
            query: (param) => ({
                url: `/accounts/get-staff/`,
                method: "get",
                params: param
            })
        }),
        deleteGymStaff:builder.mutation({
            query:(user_id) => {
                return {
                    url: `/accounts/delete-staff/${user_id}/`,
                    method: "DELETE",
                  };
            },
        }),
        updateGymStaff:builder.mutation({
            query: ({ id, data }) => {
                 
                return {
                    url: `/accounts/update-staff/${id}/`,
                    method: "PUT",
                    body: data,
                    formData: true, 
                };
            }, 
    }),
       getStaffDetails:builder.query({
        query:(id) => {
            return {
                url: `/accounts/staff-detail/${id}/`
            }
        }
       })


   
})
});

export const { useGetStaffQuery, useGetStafflistQuery , useDeleteGymStaffMutation,  
    useUpdateGymStaffMutation , useGetStaffDetailsQuery
    } = StaffApi;
